import { render, staticRenderFns } from "./Highscores.vue?vue&type=template&id=0818f309&scoped=true&"
import script from "./Highscores.vue?vue&type=script&lang=js&"
export * from "./Highscores.vue?vue&type=script&lang=js&"
import style0 from "./Highscores.vue?vue&type=style&index=0&id=0818f309&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0818f309",
  null
  
)

export default component.exports